import type {
  IBiggestCountCasesDto,
  IBonusPiecesDto,
  IDropItemDto,
  IMotivatorDto,
  IMotivatorStatistic,
  IMotivatorTop24Item,
  IMotivatorType,
  IP2pItemCreated,
  IUpgraderItem,
  MotivatorSocketKeys,
} from '@dev-fast/types';

export interface IMotivatorStateModel {
  bestLastResult: IMotivatorTop24Item[];
  bestDrop: IMotivatorDto<IDropItemDto> | null;
  bigOpens: IBiggestCountCasesDto | null;
  marketList: Array<IMotivatorDto<IP2pItemCreated>>;
  bestDropsList: Array<IMotivatorDto<IDropItemDto>>;
  bestDropsListAll: Array<IMotivatorDto<IDropItemDto>>;
  bestUpgradesList: Array<IMotivatorDto<IUpgraderItem>>;
  lobbyCasesMotivator: IMotivatorStatistic;
  caseId: number | null;
  bestLastShardsDropList: Array<IMotivatorDto<IBonusPiecesDto>>;
  currentCaseMotivator: IMotivatorStatistic;
  isCaseMotivatorHidden: boolean;
  isPlayback: boolean;
  isSubscribedToLastWon: boolean;
  lastDropsList: Array<IMotivatorDto<IDropItemDto>>;
  lastUpgradesList: Array<IMotivatorDto<IUpgraderItem>>;
  lastTicketsItemsList: Array<IMotivatorDto<IDropItemDto>>;
  activeSockets: MotivatorSocketKeys[];
  topUsers: IMotivatorType | null;
  casesLast: Array<IMotivatorDto<IDropItemDto>>;
  upgradesLast: Array<IMotivatorDto<IUpgraderItem>>;
  challengesLast: Array<IMotivatorDto<IDropItemDto>>;
}

export const MOTIVATOR_INITIAL_STATE: IMotivatorStateModel = {
  bestLastResult: [],
  bestDrop: null,
  bigOpens: null,
  bestDropsList: [],
  bestDropsListAll: [],
  bestUpgradesList: [],
  bestLastShardsDropList: [],
  caseId: null,
  currentCaseMotivator: { bestLast: [] },
  isCaseMotivatorHidden: false,
  lobbyCasesMotivator: { bestLastAll: [] },
  isPlayback: true,
  isSubscribedToLastWon: true,
  lastDropsList: [],
  lastUpgradesList: [],
  lastTicketsItemsList: [],
  activeSockets: [],
  topUsers: null,
  casesLast: [],
  upgradesLast: [],
  challengesLast: [],
  marketList: [],
};
